export default "__VITE_ASSET__BhBt$ltR__"